module.exports = __webpack_public_path__ + "img/threeFingerThrowText1.b54bdc42.png";